import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { PagedResponse } from "../types/Common";
import { Mandate } from "../types/Mandate";

const fetchProfileMandates = async (authHeader: string, profileId: number) => {
  const url = new URL(`${env.verifyServiceUrl}individual/mandate/`);
  url.searchParams.set("category", "Application");
  url.searchParams.set("profile", String(profileId));

  return axios.get<PagedResponse<Mandate[]>>(url.href, {
    headers: { Authorization: authHeader },
  });
};

export const useProfileMandates = (profileId?: number) => {
  const { authHeader, hasPermission } = useAuth();

  return useQuery(
    ["profileMandates", profileId],
    () => fetchProfileMandates(authHeader, profileId as number),
    {
      // the endpoint 403s without mandate.view, which logs the user out
      enabled: Number.isInteger(profileId) && hasPermission("mandate.view"),
      retry: false,
      select: (res) => res.data,
    }
  );
};
